import { useContext, useCallback } from 'react';
import { AngularContext } from 'react-app';

const useClearUrlParams = (params: string[]) => {
  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);

  const removeParams = useCallback((notify = false) => {
    const urlParams = params.reduce((acc, param) => {
      acc[param] = undefined;
      return acc;
    }, {});

    $state.go(
      $state.current.name,
      urlParams,
      { notify, location: 'replace' },
    );
  }, [$state, params]);

  return removeParams;
};

export default useClearUrlParams;
